import React from "react";

const FilledChevronUp = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 8l6 6H6l6-6z" />
  </svg>
);

const FilledChevronDown = ({ size = 12, color = "#ccc" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 16l-6-6h12l-6 6z" />
  </svg>
);

const SortableHeader = ({ label, field, sortField, sortOrder, handleSort, sortable=true, classes="", style={}, innerRef, resizeHandle=null }) => {
  return (
    <th ref={innerRef} style={{ cursor: "pointer", ...style }} className={classes}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          fontFamily: "Montserrat",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          color: "var(--Gray-900, #212529)",
        }}
      >
        {label}

        
       {/* flexShrink: 0 — without it a long header label squeezes the sort icon
           to zero width and the th's overflow:hidden clips it out of sight. */}
       {sortable?( <span onClick={() => handleSort(field)} style={{ display: "flex", flexDirection: "column", justifyContent: "center", flexShrink: 0 }}>
          <div  class="sorticon" style={{ lineHeight: 0 }}>
            <FilledChevronUp
           
              size={12}
              color={sortField === field && sortOrder === "asc" ? "black" : "#6C757D"}
            />
          </div>
          <div class="sorticon" style={{ lineHeight: 0, marginTop: -12}}>
            <FilledChevronDown
            
              size={12}
              color={sortField === field && sortOrder === "desc" ? "black" : "#6C757D"}
            />
          </div>
        </span>):""}
      </span>
      {resizeHandle}
    </th>
  );
};

export default SortableHeader;